import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { BatchService } from "src/services/batch.services";
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
    selector: 'rm-view-batch',
    templateUrl: './view-batch.component.html',
    styleUrls: ['./view-batch.component.css']
})

export class ViewBatchComponent implements OnInit {
    selectedBatch: any;
    selected: any = null;
    batchDetailsData: any;
    disableBtn: boolean = true;

    constructor(
        private dialogRef: MatDialogRef<ViewBatchComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    // cancel() {
    //     this.dialogRef.close();
    // }

    confirm(batch) {
        this.dialogRef.close({ data: { ...batch } })
    }

    ngOnInit(): void {
        this.batchDetailsData = this.data.viewbatchData
    }

    selectBatch(e) {
        if (e) {
            this.disableBtn = false;
        }

    }

} 